import styled from '@xstyled/styled-components'
import { Block } from '../block/block'

export const ButtonGroup = styled(Block)`
  display: flex;
  flex-direction: row;
  justify-content: ${({ alignment }) => alignment ?? 'flex-start'};
  align-items: center;

  button:not(:nth-of-type(1)) {
    margin-left: ${({ buttonGap }) => buttonGap || 12}px;
  }
`
